module.exports = __webpack_public_path__ + "static/media/pmi_logo.0560190b.svg";